import { Routes, Route } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { Layout } from '@/components/layout'
import { Home, Services, Process, About, Contact, Privacy, Terms } from '@/pages'

function App() {
  return (
    <AnimatePresence mode="wait">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="process" element={<Process />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          {/* Legal pages */}
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AnimatePresence>
  )
}

function NotFound() {
  return (
    <div className="pt-32 pb-20 container min-h-screen flex flex-col items-center justify-center text-center">
      <h1 className="text-8xl font-black text-white mb-4">404</h1>
      <p className="text-2xl text-slate-400 mb-8">Page not found</p>
      <a
        href="/"
        className="btn btn-primary"
      >
        Go Home
      </a>
    </div>
  )
}

export default App
